import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import useApi from '@/hooks/useApi';
import Skeleton from '@/components/Skeleton';
import styles from './DashboardStats.module.scss';

const DashboardStats = () => {
  const { t, i18n } = useTranslation(['common']);
  const [getStats, { response, loading }] = useApi('dashboard.stats');

  useEffect(() => {
    void getStats();
  }, [getStats]);

  const isLoading = loading === true && !response;

  const monthFormatter = new Intl.DateTimeFormat(i18n.language, {
    month: 'short',
    day: 'numeric',
  });

  const completedFrom = response
    ? monthFormatter.format(new Date(response.completedThisMonthSince))
    : null;

  return (
    <section className={styles.grid}>
      <article className={classNames(styles.card, styles.cardHighlighted)}>
        <div className={styles.label}>
          {t('common:dashboard.stats.awaiting.label')}
        </div>
        <div className={styles.value}>
          {isLoading ? (
            <Skeleton className={styles.valueSkeleton} />
          ) : (
            (response?.awaitingSignature ?? 0)
          )}
        </div>
      </article>

      <article className={styles.card}>
        <div className={styles.label}>
          {t('common:dashboard.stats.waiting.label')}
        </div>
        <div className={styles.value}>
          {isLoading ? (
            <Skeleton className={styles.valueSkeleton} />
          ) : (
            (response?.active ?? 0)
          )}
        </div>
      </article>

      <article className={styles.card}>
        <div className={styles.label}>
          {t('common:dashboard.stats.completed.label')}
        </div>
        <div className={styles.value}>
          {isLoading ? (
            <Skeleton className={styles.valueSkeleton} />
          ) : (
            (response?.completedThisMonth ?? 0)
          )}
        </div>
        <div className={styles.subtitle}>
          {isLoading || !completedFrom ? (
            <Skeleton className={styles.subtitleSkeleton} />
          ) : (
            t('common:dashboard.stats.completed.subtitle', {
              from: completedFrom,
            })
          )}
        </div>
      </article>
    </section>
  );
};

export default DashboardStats;
